import {Base} from "@/api/Base"

export class RoleEdit extends Base {
    path = "role/edit"
}